import { render, staticRenderFns } from "./GuideImgList.vue?vue&type=template&id=20e54573&scoped=true&"
import script from "./GuideImgList.vue?vue&type=script&lang=js&"
export * from "./GuideImgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e54573",
  null
  
)

export default component.exports